import { render } from "./joberpacketrequests.vue?vue&type=template&id=58f6db1c"
import script from "./joberpacketrequests.vue?vue&type=script&lang=js"
export * from "./joberpacketrequests.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__